<!-- Alert -->
@if (showAlert) {
    <fuse-alert
        class="sign-in-form-fuse-alert"
        [appearance]="'outline'"
        [showIcon]="false"
        [type]="alert.type"
        [@shake]="alert.type === 'error'">
        {{alert.message}}
    </fuse-alert>
}

@if (passwordExpired) {
    <div class="sign-in-form-password-expired">
        <a
            class="auth-form-link sign-in-form-password-expired-link"
            [routerLink]="['/expired-password']">
            Change your password now
        </a>
    </div>
}

<!-- Sign in form -->
<form
    class="auth-form-wrapper-shallow sign-in-form"
    [formGroup]="signInForm"
    #signInNgForm="ngForm">

    <!-- Username field -->
    <mat-form-field class="auth-form-field sign-in-form-field">
        <mat-label>Email address</mat-label>
        <input
            matInput
            id="username"
            autocomplete="username"
            inputmode="email"
            [formControlName]="'username'" />

        @if (signInForm.get('username')?.hasError('required')) {
            <mat-error>Please enter your email address</mat-error>
        }
        @if (signInForm.get('username')?.hasError('email')) {
            <mat-error>Please enter a valid email address</mat-error>
        }
    </mat-form-field>

    <!-- Password field -->
    <mat-form-field class="auth-form-field sign-in-form-field">
        <mat-label>Password</mat-label>
        <input
            matInput
            id="password"
            type="password"
            autocomplete="current-password"
            [formControlName]="'password'"
            #passwordField />
        <button
            mat-icon-button
            type="button"
            (click)="passwordField.type === 'password' ? passwordField.type = 'text' : passwordField.type = 'password'"
            matSuffix>
            @if (passwordField.type === 'password') {
                <mat-icon
                    class="auth-form-field-icon show-password-icon"
                    [svgIcon]="'heroicons_solid:eye'"></mat-icon>
            }
            @else {
                <mat-icon
                    class="auth-form-field-icon"
                    [svgIcon]="'heroicons_solid:eye-slash'"></mat-icon>
            }
        </button>
        <mat-error>
            Please enter your password
        </mat-error>
    </mat-form-field>

    <!-- Activity timer: starts when username/password have values -->
    <activity-timer
        [watchedValue]="activityWatchedValue"
        [timeoutSeconds]="90"
        (timedOut)="onActivityTimedOut()"></activity-timer>

    <!-- Actions -->
    <div class="auth-actions sign-in-form-actions">
        <mat-checkbox
            class="sign-in-form-remember-me-checkbox"
            [color]="'primary'"
            [formControlName]="'keepMeSignedIn'">
            Remember me
        </mat-checkbox>
        <a
            id="forgot-password"
            class="auth-form-link sign-in-form-forgot-password-link"
            (click)="forgetPassword()">Forgot password?
        </a>
    </div>

    <!-- Submit button -->
    <button
        class="auth-form-button sign-in-form-submit-button fuse-mat-button-large"
        mat-flat-button
        [color]="'primary'"
        [disabled]="signInForm.disabled || !signInForm.valid"
        (click)="signIn()">

        @if (signInForm.disabled) {
            <mat-progress-spinner
                [diameter]="24"
                [mode]="'indeterminate'">
            </mat-progress-spinner>
        }
        @else {
            <span>Sign in</span>
        }


    </button>
</form>
